import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { NotificationBannerApiResponse } from "@app/core/shared/domain/api-types-filtered";

export class GetNotificationBannerMapper {
  static deserialize(data: NotificationBannerApiResponse): MarketingMessage {
    return new MarketingMessage({
      id: String(data.id),
      m_type: "personal",
      show: data.show,
      location: null,
      title: data.title ?? "",
      titleStyle: data.titleStyle,
      subtitle: data.subtitle ?? undefined,
      subtitleStyle: data.subtitleStyle,
      message: data.message ?? "",
      messageStyle: data.messageStyle,
      image: data.image,
      imageStyle: data.imageStyle,
      textAlign: data.textAlign || "center",
      closeButtonTop: data.closeButtonTop,
      closeButtonTopStyle: data.closeButtonTopStyle,
      fullscreen: data.fullscreen,
      links: undefined,
      buttonsConfig: (data.rightButton
        ? [
            {
              translation: data.rightButton.text,
              text: data.rightButton.text,
              action_string: data.rightButton.action ?? "true",
              ui_color: data.rightButton.color ?? "primary",
              redirectUrl: data.rightButton.redirectUrl,
              class: "col-span-12",
            },
          ]
        : []) as any,
    });
  }
}
